<template>
  <div :style="getElementStyle">
    <div
      v-show="!isFromDocument ? data.properties.filed_content != 'Hide' : true"
    >
      <div :style="isFromDocument ? getStyleInDocument : ''">
        <div
          :class="isFromDocument ? '' : ''"
          :style="isFromDocument ? getStyleInDocument : ''"
        >
          <el-row align="middle">
            <el-col
              :span="
                showLabel && !isDefalutPosq ? 4 : data.description ? 4 : 24
              "
              v-if="
                data &&
                data.properties &&
                !data.properties.hideLabel &&
                hasLabel
              "
              :style="computedStyles"
              class="bottom-space"
            >
              <label
                style="white-space: wrap"
                for="text"
                :style="getLabelStyles"
                v-if="!fromRepeatable && !isFromDocument && !profilePage"
                >{{ label || data.label }}</label
              >
              <span
                v-if="data.validations.required"
                style="color: red; font-weight: bold"
              >
                *
              </span>

              <el-popover
                v-if="data.description && !isFromDocument"
                placement="top-start"
                trigger="hover"
                :content="data.description"
              >
                <i class="el-icon-info" slot="reference"></i>
              </el-popover>
            </el-col>
            <el-col
              v-else-if="!isFromDocument"
              :span="showLabel ? 4 : data.description ? 20 : 24"
              ref="colRef"
              :style="computedStyles"
            >
              <span
                v-if="hasLabel"
                style="
                  color: white;
                  display: inline-block;
                  height: 20px;
                  opacity: 0;
                "
              ></span>
            </el-col>
            <el-button
              type="text"
              :underline="false"
              v-if="
                data.is_entity_variable &&
                data.field_assignable != 'read_only' &&
                checkIsCountField
              "
              @click="openDetailedView"
            >
              <template
                v-if="form[data.key] !== undefined && form[data.key] !== null"
              >
                <span
                  v-if="
                    (data.validations.currency || checkIsCurrency) &&
                    data.validations.resultt_type != 'percentage'
                  "
                >
                  {{
                    form[data.key]
                      | toIndianCurrency(
                        data && data.validatoins && data.validations.currency
                          ? data.validation.currency
                          : checkIsCurrency.currency_type
                      )
                  }}
                </span>
                <span v-else-if="checkIsTime">
                  {{ form[data.key] | toTimeFormat(data.time_result_type) }}
                </span>
                <span v-else-if="isDateTime(form[data.key])">
                  {{ form[data.key] | globalDateTimeFormat }}
                </span>
                <span v-else-if="isDate(form[data.key])">
                  {{ form[data.key] | globalDateFormat }}
                </span>
                <span v-else-if="data.validations.resultt_type == 'percentage'">
                  {{ percentageValue }}
                </span>
                <span v-else>
                  {{ form[data.key] }}
                </span>
              </template>
              <template
                v-else-if="data.validations.resultt_type == 'percentage'"
              >
                {{ percentageValue }}
              </template>
              <template v-else>-</template>
            </el-button>
            <section v-else>
              <el-col
                :span="showLabel && !isDefalutPosq ? 12 : 24"
                class="fontSty"
              >
                <div
                  v-if="
                    data.validations.resultt_type == 'percentage' && !isView
                  "
                >
                  <el-input
                    :value="percentageValue"
                    type="text"
                    :readonly="!isEditable"
                    :placeholder="data.key"
                    :id="data.key"
                    :style="isFromDocument ? getStyleInDocument : ''"
                    :class="{
                      'disabled-field': checkIsDisabled,
                      'left-aligned-input': textAlignment === 'left',
                      'right-aligned-input': textAlignment === 'right',
                      'center-aligned-input': textAlignment === 'center',
                    }"
                    @input="changeValue"
                  />
                </div>
                <div
                  v-if="!isView"
                  :style="isFromDocument ? getStyleInDocument : ''"
                >
                  <div
                    v-if="
                      (checkIsCurrency || data.validations.currency) &&
                      data.validations.resultt_type !== 'percentage'
                    "
                    :style="isFromDocument ? getStyleInDocument : ''"
                  >
                    <currency-input
                      v-if="
                        data.validations.currency &&
                        data.validations.resultt_type !== 'percentage'
                      "
                      :locale="data.validations.locale"
                      :placeholder="data.key"
                      :currency="data.validations.currency"
                      :value="normalizeCurrencyValue(form[data.key])"
                      class="el-input__inner"
                      :style="isFromDocument ? getStyleInDocument : ''"
                      :readonly="!isEditable"
                      :id="data.key"
                      :precision="
                        data.decimals != null ? Number(data.decimals) : 2
                      "
                      :suffix-icon="
                        data.properties && data.properties.el_icon
                          ? data.properties.el_icon
                          : ''
                      "
                      :class="{
                        'disabled-field': checkIsDisabled,
                        'left-aligned-input': textAlignment === 'left',
                        'right-aligned-input': textAlignment === 'right',
                        'center-aligned-input': textAlignment === 'center',
                      }"
                      @input="changeValue"
                    />

                    <currency-input
                      v-else
                      :placeholder="data.key"
                      :style="isFromDocument ? getStyleInDocument : ''"
                      :currency="checkIsCurrency.currency_type"
                      :value="normalizeCurrencyValue(form[data.key])"
                      :readonly="!isEditable"
                      :class="
                        isFromDocument ? 'custom-input' : 'el-input__inner'
                      "
                      :id="data.key"
                      :suffix-icon="
                        data.properties && data.properties.el_icon
                          ? data.properties.el_icon
                          : ''
                      "
                      @input="changeValue"
                    />

                    <!-- <span style="display: none" v-if="!isFromDocument">
                    {{ parseFloat(getValue).toFixed(this.data.decimals) }}
                  </span> -->
                  </div>

                  <div v-else :style="isFromDocument ? getStyleInDocument : ''">
                    <span
                      v-if="
                        data.currency &&
                        data.validations.resultt_type !== 'percentage'
                      "
                    >
                      <currency-input
                        v-if="data.validations.resultt_type !== 'percentage'"
                        :placeholder="data.key"
                        :currency="data.currency"
                        :value="normalizeCurrencyValue(form[data.key])"
                        :readonly="!isEditable"
                        class="el-input__inner"
                        :style="isFromDocument ? getStyleInDocument : ''"
                        :id="data.key"
                        :suffix-icon="
                          data.properties && data.properties.el_icon
                            ? data.properties.el_icon
                            : ''
                        "
                        :class="{
                          'disabled-field': checkIsDisabled,
                          'left-aligned-input': textAlignment === 'left',
                          'right-aligned-input': textAlignment === 'right',
                          'center-aligned-input': textAlignment === 'center',
                        }"
                        @input="changeValue"
                    /></span>
                    <input
                      v-if="
                        checkIsTime &&
                        !isDate(form[data.key]) &&
                        data.validations.resultt_type !== 'percentage'
                      "
                      :placeholder="data.key"
                      :value="
                        form[data.key] !== undefined
                          ? getTimeFormatedValue(form[data.key])
                          : ''
                      "
                      :readonly="!isEditable"
                      :style="{
                        'text-align': inputTextAlignment,
                        ...(isFromDocument ? getStyleInDocument : getStyle),
                      }"
                      :suffix-icon="
                        data.properties && data.properties.el_icon
                          ? data.properties.el_icon
                          : ''
                      "
                      :id="data.key"
                      class="nfe"
                      @input="changeValue"
                    />
                    <input
                      v-if="
                        !data.currency &&
                        !isFromDocument &&
                        !checkIsTime &&
                        !isDate(form[data.key]) &&
                        data.result_type != 'DATE' &&
                        data.validations.resultt_type !== 'percentage'
                      "
                      :placeholder="data.key"
                      class="nfe"
                      v-model="form[data.key]"
                      :readonly="!isEditable"
                      :style="{
                        'text-align': inputTextAlignment,
                        ...(isFromDocument ? getStyleInDocument : getStyle),
                      }"
                      :id="data.key"
                      :suffix-icon="
                        data.properties && data.properties.el_icon
                          ? data.properties.el_icon
                          : ''
                      "
                      :class="{
                        'disabled-field': checkIsDisabled,
                        'left-aligned-input': textAlignment === 'left',
                        'right-aligned-input': textAlignment === 'right',
                        'center-aligned-input': textAlignment === 'center',
                      }"
                      @input="changeValue"
                    />
                    <input
                      v-if="
                        !data.currency &&
                        isFromDocument &&
                        !checkIsTime &&
                        !isDate(form[data.key]) &&
                        data.validations.resultt_type !== 'percentage'
                      "
                      :placeholder="data.key"
                      :style="{
                        'text-align': inputTextAlignment,
                        ...getStyleInDocument,
                      }"
                      v-model="form[data.key]"
                      :readonly="!isEditable"
                      :suffix-icon="
                        data.properties && data.properties.el_icon
                          ? data.properties.el_icon
                          : ''
                      "
                      :id="data.key"
                      class="el-input"
                      @input="changeValue"
                    />
                    <el-input
                      v-if="
                        isTime(form[data.key]) &&
                        data.validations.resultt_type !== 'percentage'
                      "
                      :placeholder="data.placeholder || data.label"
                      v-model="form[data.key]"
                      prefix-icon="el-icon-date"
                      :readonly="!isEditable"
                      @input="changeValue"
                    >
                    </el-input>
                    <el-date-picker
                      v-if="
                        (isDate(form[data.key]) ||
                          data.result_type == 'DATE') &&
                        !isTime(form[data.key]) &&
                        data.validations.resultt_type !== 'percentage'
                      "
                      prefix-icon="el-icon-date"
                      v-model="form[data.key]"
                      :readonly="!isEditable"
                      :type="isDateTime() ? 'datetime' : 'date'"
                      :placeholder="data.placeholder || data.label"
                      :format="
                        isDateTime()
                          ? 'MM-dd-yyyy HH:mm:ss'
                          : getDefaultDateFormat &&
                            getDefaultDateFormat.includes('Do') == false
                          ? getDefaultDateFormat
                              .replace('YYYY', 'yyyy')
                              .replace('DD', 'dd')
                          : 'MM-dd-yyyy'
                      "
                      @input="changeValue"
                    >
                    </el-date-picker>
                    <!-- <span style="display: none" v-if="!isFromDocument">{{
                    parseFloat(getValue).toFixed(this.data.decimals)
                  }}</span> -->
                  </div>
                </div>
              </el-col>

              <div
                v-if="isView"
                :style="{ textAlign: inputTextAlignment() }"
                class="fontSty"
              >
                <template
                  v-if="form[data.key] !== undefined && form[data.key] !== null"
                >
                  <span
                    v-if="
                      data.validations.currency &&
                      data.validations.resultt_type != 'percentage'
                    "
                  >
                    {{
                      form[data.key]
                        | toIndianCurrency(data.validations.currency)
                    }}
                  </span>
                  <span v-else-if="checkIsTime">
                    {{ form[data.key] | toTimeFormat(data.time_result_type) }}
                  </span>
                  <div v-else-if="isDateTime(form[data.key])">
                    {{ form[data.key] | globalDateTimeFormat }}
                  </div>
                  <div v-else-if="isDate(form[data.key])">
                    {{ form[data.key] | globalDateFormat }}
                  </div>
                  <div
                    v-else-if="data.validations.resultt_type == 'percentage'"
                  >
                    {{ percentageValue }}
                  </div>
                  <div v-else>
                    {{ form[data.key] }}
                  </div>
                </template>
                <template
                  v-else-if="data.validations.resultt_type == 'percentage'"
                >
                  {{ percentageValue }}
                </template>
                <template v-else>-</template>
              </div>
            </section>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userPermissionsHelper from "@/mixins/userPermissionsHelper";
import * as mexp from "math-expression-evaluator";
import CurrencyInput from "./../../vue-weblineindia-currency-input/src/component";
import { mapGetters } from "vuex";
import * as moment from "moment";
import { bus } from "../../../main";
// import { debounce } from "@/helpers/lodashHelper.js";
import { fetchGlobalVariables } from "@/repo/globalVariables";
import { getWorker, releaseWorker } from "@/utils/FormulaWorkerFactory";
import { fetchEntityById } from "../../../repo/entityRepo";

export default {
  mixins: [userPermissionsHelper],
  components: {
    CurrencyInput,
  },
  props: [
    "dataTableField",
    "isInDataTable",
    "label",
    "colorFields",
    "data",
    "form",
    "templatesData",
    "workflowData",
    "fromRepeatable",
    "isView",
    "isFromDocument",
    "allFields",
    "company_id",
    "document_id",
    "isEntityVariable",
    "originalField",
    "entityDataId",
    "isDisable",
    "profilePage",
    "parentFormData",
    "fieldsData",
    "hasLabel",
    "checkIsDisabled",
    "fromEntityViews",
    "loadingButtonFields",
    "labelAlignments",
    "dataTableRowIndex",
    "parentEntityData",
    "entityFieldDatas",
  ],
  data() {
    return {
      currency: "",
      formulaWorker: null,
      parentFormDataDebounce: null,
      formDebounce: null,
      applyRulesDebounce: null,
      validations: [],
      showLabel: true,
      isDefalutPos: true,
      fieldvalue: "",
      result_type: "NUMBER",
      previous_form: {},
      textAlignment: "left",
      getAllGlobalVariables: null,
      isEditable: false,
    };
  },
  computed: {
    ...mapGetters("templatesData", ["getTemplatesData"]),
    //...mapGetters("globalVariables", ["getAllGlobalVariables"]),
    ...mapGetters("auth", ["getDefaultDateFormat"]),
    getStyle() {
      return `height:${this.data.height - 30}px; width: ${
        this.data.width
      }px !important;`;
    },
    percentageValue: {
      get() {
        return (Number(this.form[this.data.key]) || 0) + " %";
      },
      set(value) {
        this.form[this.data.key] = String(value);
      },
    },
    getTimeFormatedValue() {
      return (value) => {
        let format =
          this.data.time_result_type && this.data.time_result_type !== ""
            ? this.data.time_result_type
            : "Time";
        if (this.isEntityVariable) {
          let finalValue = "";
          switch (format) {
            case "Time":
              finalValue += value;
              break;
            case "HH":
              finalValue += value + " Hrs";
              break;
            case "MM":
              finalValue += value + " Mins";
              break;
            case "SS":
              finalValue += value + " Secs";
              break;
          }
          return finalValue;
        }
        return this.$options.filters.toTimeFormat(value, format);
      };
    },
    getStyleInDocument() {
      // height:${this.data.height - 30}px;
      return ` width:99.60% !important; font-size:${
        this.data.font && this.data.font.size ? this.data.font.size : "16"
      }px;font-style: ${
        (this.data && this.data.font && this.data.font.style == 2) ||
        (this.data && this.data.font && this.data.font.style == 3)
          ? "italic"
          : "normal"
      };font-weight:${
        (this.data && this.data.font && this.data.font.style == 1) ||
        (this.data && this.data.font && this.data.font.style == 3)
          ? "bold"
          : "normal"
      };color:${
        this.data && this.data.font && this.data.font.color
          ? this.data.font.color
          : "black"
      };font-family:${
        this.data && this.data.font && this.data.font.name
          ? this.data.font.name
          : "helvetica"
      }`;
    },
    isDefalutPosq() {
      if (this.data?.styles?.labelStyle == "right") {
        return false;
      } else {
        return true;
      }
    },
    checkIsCurrency() {
      if (this.data.selected_fields && this.data.selected_fields.length) {
        return this.data.selected_fields.find(
          (e) => e.input_type == "CURRENCY"
        );
      }
      return false;
    },
    checkIsTime() {
      if (this.data.selected_fields && this.data.selected_fields.length) {
        return this.data.selected_fields.find((e) => e.input_type == "TIME");
      }
      return false;
    },
    is_date() {
      return (input) => {
        if (Object.prototype.toString.call(input) === "[object Date]")
          return true;
        return false;
      };
    },

    computedStyles() {
      const styles = {};

      // Set display to flex
      styles.display = "flex";

      // Set justify-content based on data.styles.labelAlignments
      if (this.labelAlignments || this.data?.styles?.labelAlignments) {
        styles.justifyContent =
          this.labelAlignments || this.data?.styles?.labelAlignments;
      }

      // Add other dynamic styles if needed

      return styles;
    },
    checkIsCountField() {
      if (this.data?.relationship_key) {
        let fields = [];
        if (this.isInDataTable) {
          fields = this.fieldsData.find(
            (fd) => fd.key == this.data.data_table_key
          ).data_table_columns;
        } else {
          fields = this.fieldsData;
        }
        let parent = (fields || []).find(
          (e) => e.key == this.data.relationship_key
        );
        if (
          parent?.allow_multiple &&
          (["NUMBER", "CURRENCY", "AGGREGATE_FUNCTION"].indexOf(
            this.data.inputType
          ) != -1 ||
            (this.data.inputType == "FORMULA" &&
              ["NUMBER", "CURRENCY", "AGGREGATE_FUNCTION"].indexOf(
                this.data.result_type
              ) != -1))
        ) {
          return true;
        }
      }
      return false;
    },
  },
  async created() {
    bus.$on("formula-updated", () => {
      this.getValueForDocument();
    });
    if (this.isInDataTable) {
      bus.$on(
        `detailed-view-${this.data.key}-${this.dataTableRowIndex}`,
        async () => {
          await this.openDetailedView();
        }
      );
      bus.$on(`editable-${this.data.key}-${this.dataTableRowIndex}`, () => {
        this.isEditable = true;
      });
      bus.$on(
        `remove-editable-${this.data.key}-${this.dataTableRowIndex}`,
        () => {
          this.isEditable = false;
        }
      );
    } else {
      bus.$on(`editable-${this.data.key}`, () => {
        this.isEditable = true;
      });
      bus.$on(`remove-editable-${this.data.key}`, () => {
        this.isEditable = false;
      });
    }
    this.formulaWorker = await getWorker();
  },
  async beforeDestroy() {
    await releaseWorker();
    clearTimeout(this.parentFormDataDebounce);
    clearTimeout(this.formDebounce);
    clearTimeout(this.applyRulesDebounce);
    bus.$off("formula-updated");
    if (this.isInDataTable) {
      bus.$off(`detailed-view-${this.data.key}-${this.dataTableRowIndex}`);
      bus.$off(`editable-${this.data.key}-${this.dataTableRowIndex}`);
      bus.$off(`remove-editable-${this.data.key}-${this.dataTableRowIndex}`);
    } else {
      bus.$off(`editable-${this.data.key}`);
      bus.$off(`remove-editable-${this.data.key}`);
    }
  },
  async mounted() {
    try {
      await this.setWorkerData();
    } catch (e) {
      console.log(e);
      // swallow to avoid unhandled promise error during mount if worker is not ready
    }
    if (this.data.styles && this.data.styles.labelStyle) {
      if (this.data.styles && this.data.styles.labelStyle == "hide") {
        this.showLabel = false;
      }
    }

    if (this.data.validations.resultt_type == "percentage") {
      this.data.validations.currency = null;
      this.data.selected_fields[0].currency_type = null;
    }
    if (this.data.validations.locale === "nl-NL") {
      this.data.validations.locale = "en-IE";
    }
    if (this.data.validations.currency) {
      this.form[this.data.key + "_currency"] = this.data.validations.currency;
    } else {
      this.form[this.data.key + "_currency"] =
        this.checkIsCurrency?.currency_type;
    }
    // Getting template data

    if (this.entityDataId) {
      // this.getTemplateIdsData();
    }
    // this.getGloablVariables();

    if (this.isFromDocument) {
      this.getValueForDocument();
    }
    this.result_type = this.getResultType(this.data.selected_fields);
    bus.$on("global-date", () => {
      this.getValueGlobal();
    });
    if (!this.isView && !this.isEditable) {
      this.getValue();
    }
    if (
      this.loadingButtonFields &&
      !this.loadingButtonFields?.includes(this.data.key)
    ) {
      this.loadingButtonFields.push(this.data.key);
    }
  },
  watch: {
    parentFormData: {
      async handler(data) {
        if (
          this.isView ||
          this.isEditable ||
          this.originalField?.variable_action ||
          (this.isEntityVariable &&
            this.originalField?.input_type === "ENTITY_VARIABLE" &&
            this.originalField?.field_assignable != "editable")
        ) {
          return;
        }

        // Debounce the execution
        if (this.parentFormDataDebounce) {
          clearTimeout(this.parentFormDataDebounce);
        }

        this.parentFormDataDebounce = setTimeout(async () => {
          let current_form = {};
          this.data.selected_fields.forEach((fl) => {
            if (fl.type == "FIELD" || fl.type == "FORMULA") {
              if (this.parentFormData && this.parentFormData[fl.key]) {
                this.$set(current_form, fl.key, this.parentFormData[fl.key]);
              } else {
                if (
                  this.isEntityVariable &&
                  this.originalField?.input_type === "ENTITY_VARIABLE" &&
                  this.originalField?.field_assignable == "editable"
                ) {
                  let foundField = this.fieldsData.find(
                    (field) =>
                      field.input_type === "ENTITY_VARIABLE" &&
                      field.global_variable_entity_select_type_field_key ==
                        fl.key
                  );
                  foundField
                    ? this.$set(
                        current_form,
                        foundField.key,
                        data[foundField.key]
                      )
                    : this.$set(
                        current_form,
                        fl.key,
                        this.parentEntityData[
                          this.originalField
                            ?.global_variable_entity_field_template_id
                        ][fl.key]
                      );
                } else if (
                  this.data.data_table_key &&
                  this.data.is_entity_variable &&
                  this.data.field_assignable == "editable"
                ) {
                  let foundField = this.fieldsData.find(
                    (field) =>
                      field.input_type === "ENTITY_VARIABLE" &&
                      field.global_variable_entity_select_type_field_key ==
                        fl.key
                  );
                  if (foundField) {
                    this.$set(
                      current_form,
                      fl.key,
                      this.parentFormData[foundField.key]
                    );
                  } else {
                    data[fl.key]
                      ? this.$set(current_form, fl.key, data[fl.key])
                      : "";
                  }
                } else {
                  this.$set(current_form, fl.key, data[fl.key]);
                }
              }
            }
          });

          if (
            JSON.stringify(current_form) !== JSON.stringify(this.previous_form)
          ) {
            this.previous_form = {};
            this.data.selected_fields.forEach((fl) => {
              if (fl.type == "FIELD" || fl.type == "FORMULA") {
                if (this.parentFormData && this.parentFormData[fl.key]) {
                  this.$set(
                    this.previous_form,
                    fl.key,
                    this.parentFormData[fl.key]
                  );
                } else {
                  if (
                    this.isEntityVariable &&
                    this.originalField?.input_type === "ENTITY_VARIABLE" &&
                    this.originalField?.field_assignable == "editable"
                  ) {
                    let foundField = this.fieldsData.find(
                      (field) =>
                        field.global_variable_entity_select_type_field_key ==
                        fl.key
                    );
                    foundField
                      ? this.$set(
                          this.previous_form,
                          foundField.key,
                          data[foundField.key]
                        )
                      : this.$set(
                          this.previous_form,
                          fl.key,
                          this.parentEntityData[
                            this.originalField
                              ?.global_variable_entity_field_template_id
                          ][fl.key]
                        );
                  } else if (
                    this.data.data_table_key &&
                    this.data.is_entity_variable &&
                    this.data.field_assignable == "editable"
                  ) {
                    let foundField = this.fieldsData.find(
                      (field) =>
                        field.input_type === "ENTITY_VARIABLE" &&
                        field.global_variable_entity_select_type_field_key ==
                          fl.key
                    );
                    if (foundField) {
                      this.$set(
                        this.previous_form,
                        fl.key,
                        this.parentFormData[foundField.key]
                      );
                    } else {
                      data[fl.key]
                        ? this.$set(
                            this.previous_form,
                            fl.key,
                            this.data[fl.key]
                          )
                        : "";
                    }
                  } else {
                    this.$set(this.previous_form, fl.key, data[fl.key]);
                  }
                }
              }
            });
            await this.getValue();
          }
        }, 300);
      },
      deep: true,
    },

    form: {
      async handler(data) {
        if (
          this.isView ||
          this.isEditable ||
          this.originalField?.variable_action ||
          (this.isEntityVariable &&
            this.originalField?.input_type === "ENTITY_VARIABLE" &&
            this.originalField?.field_assignable != "editable")
        ) {
          return;
        }

        // Debounce the execution
        if (this.formDebounce) {
          clearTimeout(this.formDebounce);
        }
        this.formDebounce = setTimeout(async () => {
          let current_form = {};
          this.data.selected_fields.forEach((fl) => {
            if (fl.key == this.data.key) {
              return;
            }
            if (fl.type == "FIELD" || fl.type == "FORMULA") {
              if (this.parentFormData && this.parentFormData[fl.key]) {
                this.$set(current_form, fl.key, this.parentFormData[fl.key]);
              } else {
                if (
                  this.isEntityVariable &&
                  this.originalField?.input_type === "ENTITY_VARIABLE" &&
                  this.originalField?.field_assignable == "editable"
                ) {
                  let foundField = this.fieldsData.find(
                    (field) =>
                      field.input_type === "ENTITY_VARIABLE" &&
                      field.global_variable_entity_select_type_field_key ==
                        fl.key
                  );
                  foundField
                    ? this.$set(
                        current_form,
                        foundField.key,
                        data[foundField.key]
                      )
                    : this.$set(
                        current_form,
                        fl.key,
                        this.parentEntityData[
                          this.originalField
                            ?.global_variable_entity_field_template_id
                        ][fl.key]
                      );
                } else if (
                  this.data.data_table_key &&
                  this.data.is_entity_variable &&
                  this.data.field_assignable == "editable"
                ) {
                  let foundField = this.fieldsData.find(
                    (field) =>
                      field.input_type === "ENTITY_VARIABLE" &&
                      field.global_variable_entity_select_type_field_key ==
                        fl.key
                  );
                  if (foundField) {
                    this.$set(
                      current_form,
                      fl.key,
                      this.parentFormData[foundField.key]
                    );
                  } else {
                    data[fl.key]
                      ? this.$set(current_form, fl.key, data[fl.key])
                      : "";
                  }
                } else {
                  this.$set(current_form, fl.key, data[fl.key]);
                }
              }
            }
          });
          if (
            JSON.stringify(current_form) !== JSON.stringify(this.previous_form)
          ) {
            this.previous_form = {};
            this.data.selected_fields.forEach((fl) => {
              if (fl.key == this.data.key) {
                return;
              }
              if (fl.type == "FIELD" || fl.type == "FORMULA") {
                if (this.parentFormData && this.parentFormData[fl.key]) {
                  this.$set(
                    this.previous_form,
                    fl.key,
                    this.parentFormData[fl.key]
                  );
                } else {
                  if (
                    this.isEntityVariable &&
                    this.originalField?.input_type === "ENTITY_VARIABLE" &&
                    this.originalField?.field_assignable == "editable"
                  ) {
                    let foundField = this.fieldsData.find(
                      (field) =>
                        field.global_variable_entity_select_type_field_key ==
                        fl.key
                    );
                    foundField
                      ? this.$set(
                          this.previous_form,
                          foundField.key,
                          data[foundField.key]
                        )
                      : this.$set(
                          this.previous_form,
                          fl.key,
                          this.parentEntityData[
                            this.originalField
                              ?.global_variable_entity_field_template_id
                          ][fl.key]
                        );
                  } else if (
                    this.data.data_table_key &&
                    this.data.is_entity_variable &&
                    this.data.field_assignable == "editable"
                  ) {
                    let foundField = this.fieldsData.find(
                      (field) =>
                        field.input_type === "ENTITY_VARIABLE" &&
                        field.global_variable_entity_select_type_field_key ==
                          fl.key
                    );
                    if (foundField) {
                      this.$set(
                        this.previous_form,
                        fl.key,
                        this.parentFormData[foundField.key]
                      );
                    } else {
                      data[fl.key]
                        ? this.$set(
                            this.previous_form,
                            fl.key,
                            this.data[fl.key]
                          )
                        : "";
                    }
                  } else {
                    this.$set(this.previous_form, fl.key, data[fl.key]);
                  }
                }
              }
            });
            await this.getValue();
          }

          if (
            this.form[this.data.key] !== this.fieldvalue &&
            !this.isInDataTable
          ) {
            this.fieldvalue = this.form[this.data.key];
            // Debounce applyFormRules separately
            if (this.applyRulesDebounce) {
              clearTimeout(this.applyRulesDebounce);
            }
            this.applyRulesDebounce = setTimeout(() => {
              this.applyFormRules();
            }, 500);
          }
        }, 300);
      },
      deep: true,
    },
    "data.styles.inputTextAlignments": {
      handler(newVal) {
        this.textAlignment = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    changeValue(value){
      if(this.isEditable){
        this.$set(this.form, this.data.key, value);
      }
    },
    normalizeCurrencyValue(val) {
      const n = Number(val);
      return Number.isFinite(n) ? n : 0;
    },
    async openDetailedView() {
      let fields = [];
      if (this.isInDataTable) {
        fields = this.fieldsData.find(
          (fd) => fd.key == this.data.data_table_key
        ).data_table_columns;
      } else {
        fields = this.fieldsData;
      }
      let parent = (fields || []).find(
        (e) => e.key == this.data.relationship_key
      );
      let currentEntity = await fetchEntityById(parent.entity_id);
      let parentData = this.form[parent.key];
      let parentLabel = this.form[parent.key + "/name"];
      this.$emit(
        "openDetailedView",
        currentEntity,
        parent,
        parentLabel,
        parentData,
        this.dataTableRowIndex,
        this.data
      );
    },
    isDateTime() {
      let dateTime = (this.data?.selected_fields || []).filter(
        (e) => e.input_type == "DATE_TIME"
      );
      return dateTime && dateTime.length === 1 ? true : false;
    },
    copyDocument() {
      this.$emit("copy-document", this.data.key);
    },
    async setWorkerData() {
      // Ensure worker exists before attempting to set data
      if (!this.formulaWorker) {
        try {
          this.formulaWorker = await getWorker();
        } catch (e) {
          return;
        }
      }
      if (!this.formulaWorker) {
        return;
      }
      // If formula depends on Entity Variable data, ensure parent entity context exists
      if (
        this.isEntityVariable &&
        this.originalField?.input_type === "ENTITY_VARIABLE"
      ) {
        const tmplId =
          this.originalField?.global_variable_entity_field_template_id;
        if (
          tmplId &&
          (!this.parentEntityData || !this.parentEntityData[tmplId])
        ) {
          // Parent entity template data not ready; skip pushing globals now
          return;
        }
      }
      // For shared worker, prefer setGlobalStore; fallback to setStoreData if not available
      const payload = JSON.parse(
        JSON.stringify({
          fieldsData: this.fieldsData,
          allGlobalVariables: this.getAllGlobalVariables || [],
          field: this.data,
          defaultDateFormat: this.globalDateFormat || "MM-DD-YYYY",
          templatesData: this.getTemplatesData || [],
        })
      );
      if (this.formulaWorker && this.formulaWorker.setGlobalStore) {
        const globals = { ...payload };
        delete globals.field;
        await this.formulaWorker.setGlobalStore(globals);
      } else if (this.formulaWorker && this.formulaWorker.setStoreData) {
        await this.formulaWorker.setStoreData(payload);
      } else {
        return;
      }
    },
    async getValue() {
      if (this.isFromDocument) {
        return "";
      }
      if (
        this.isEntityVariable &&
        this.originalField.input_type === "ENTITY_VARIABLE" &&
        this.originalField.field_assignable != "editable"
      ) {
        return;
      }
      let isFormulaFieldAsEditableEntityVariable =
        (this.isEntityVariable &&
          this.originalField?.input_type === "ENTITY_VARIABLE" &&
          this.originalField?.field_assignable == "editable") ||
        (this.data.data_table_key &&
          this.data.is_entity_variable &&
          this.data.field_assignable == "editable")
          ? true
          : false;
      let finalValue;
      if (this.formulaWorker && this.formulaWorker.calculateFor) {
        finalValue = await this.formulaWorker.calculateFor(
          this.data,
          this.form,
          this.parentFormData,
          this.parentEntityData,
          isFormulaFieldAsEditableEntityVariable
        );
      } else if (this.formulaWorker) {
        // Fallback for old workers
        await this.formulaWorker.setStoreData(
          JSON.parse(
            JSON.stringify({
              fieldsData: this.fieldsData,
              allGlobalVariables: this.getAllGlobalVariables || [],
              field: this.data,
              defaultDateFormat: this.globalDateFormat || "MM-DD-YYYY",
              templatesData: this.getTemplatesData || [],
            })
          )
        );
        finalValue = await this.formulaWorker.calculateValue(
          this.form,
          this.parentFormData,
          this.parentEntityData,
          isFormulaFieldAsEditableEntityVariable
        );
      } else {
        // No worker available, do local computation
        const fields = this.data?.selected_fields || [];
        const dataMap = { ...this.form };
        finalValue = this.setValueBasedOnFields(fields, dataMap);
      }
      this.$set(this.form, this.data.key, finalValue);
      return finalValue;
    },
    inputTextAlignment() {
      return this.data.result_type == "DATE" ? "left" : this.textAlignment; // Set a default value if not provided
    },
    getResultType(fields = []) {
      let type = "NUMBER";
      if (fields.length) {
        let timeFields = fields.filter(
          (e) =>
            e.input_type == "TIME" ||
            (e.type == "FORMULA" && e.result_type == "TIME") ||
            (e.type == "GLOBAL_VARIABLE" && e.inputType == "TIME")
        );
        let dateFields = fields.filter(
          (e) =>
            e.input_type == "DATE" ||
            (e.type == "FORMULA" && e.result_type == "DATE") ||
            (e.type == "GLOBAL_VARIABLE" && e.inputType == "DATE")
        );

        let currencyField = fields.filter(
          (e) =>
            e.input_type == "CURRENCY" ||
            (e.type == "FORMULA" && e.result_type == "CURRENCY") ||
            (e.type == "GLOBAL_VARIABLE" && e.inputType == "CURRENCY")
        );
        if (currencyField && currencyField.length) {
          type = "CURRENCY";
        } else if (dateFields && dateFields.length == 1) {
          type = "DATE";
        } else if (timeFields && timeFields.length == 1) {
          type = "TIME";
        }
      }
      return type;
    },
    checkDate(string) {
      var dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      var dateRegex1 = /^\d{2}-\d{2}-\d{4}$/;
      var timeRegex = /^\d{2}:\d{2}:\d{2}$/;
      let dateStamp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
      if (timeRegex.test(string)) {
        // return moment("2000-01-01 " + string, "YYYY-MM-DD HH:mm:ss");
      } else {
        if (
          dateRegex.test(string) ||
          dateRegex1.test(string) ||
          dateStamp.test(string)
        ) {
          return string;
        } else {
          // return moment().utc().format();
        }
      }
    },
    convertSecondsToHoursMinutes(seconds, outputType) {
      if (outputType === "hours" || outputType === "hh") {
        const hours = Math.floor(seconds / 3600);

        return hours;
      } else if (outputType === "minutes" || outputType === "mm") {
        const minutes = Math.floor(seconds / 60);

        return minutes;
      } else {
        return seconds;
      }
    },

    convertHoursMinutesToSeconds(value, inputType) {
      if (inputType === "hours" || inputType === "hh") {
        const seconds = value * 3600;

        return seconds;
      } else if (inputType === "minutes" || inputType === "mm") {
        const seconds = value * 60;

        return seconds;
      } else {
        return value;
      }
    },
    applyFormRules() {
      this.$emit("applyFormRules");
    },
    getValueGlobal() {
      if (this.isFromDocument) {
        return "";
      }
      let fields = this.data.selected_fields;

      let data = {};
      if (Object.keys(this.form).length) {
        Object.keys(this.form).forEach((key) => {
          if (key.indexOf("#") > -1) {
            data[key.split("#")[1]] = this.form[key];
          } else {
            if (this.data.selected_fields[0].input_type === "CURRENCY") {
              data[key] = this.form[key];
            } else if (this.data.selected_fields[0].input_type === "TIME") {
              data[key] = this.form[key];
            } else if (this.data.selected_fields) {
              data[key] = this.form[key];
            } else {
              data[key] = parseFloat(this.form[key]).toFixed(
                this.data.decimals
              );
            }
          }
        });
      }

      return this.setValueBasedOnFields(fields, data);

      // }
    },

    getValueForDocument() {
      let fields = this.data.selected_fields;
      let data = {};
      if (this.allFields && this.allFields.length) {
        this.allFields.forEach((field) => {
          data[field.key] = field.value;
        });
        data = { ...data, ...this.form };
      }
      return this.setValueBasedOnFields(fields, data);
    },
    checkReadonly() {
      if (this.checkIsDisabled) {
        return true;
      }
      //If it's an entity varaible, have to check access

      if (
        this.data.field_assignable === "read_only" &&
        this.data.is_entity_variable
      ) {
        return true;
      }
      return !this.fieldFilledByCurrentUser(this.data.filled_by);
    },
    async getTemplateIdsData() {
      let templateIds = [];
      this.data.selected_fields.forEach((element) => {
        if (element.template_id) {
          if (templateIds.indexOf(element.template_id) < 0) {
            templateIds.push(element.template_id);
          }
        }
      });
      let params = {
        template_ids: templateIds,
        entity_data_id: this.entityDataId,
        status: "ACTIVE",
      };
      await this.$store.dispatch("templatesData/fetchUserTemplateData", params);
    },
    getTemplateValue(templateId, key) {
      let value = 0;
      if (this.getTemplatesData && this.getTemplatesData.length) {
        this.getTemplatesData.forEach((item) => {
          if (item.template_id == templateId) {
            value =
              item.template_data && item.template_data[key]
                ? item.template_data[key]
                : "";
          }
        });
        return value ? value : "";
      }
    },
    async getGloablVariables() {
      let params = {
        get_all: true,
      };
      if (this.company_id && this.document_id) {
        params["company_id"] = this.company_id;
        params["document_id"] = this.document_id;
      }
      this.getAllGlobalVariables = await fetchGlobalVariables(params);
    },
    getGlobalVariableValue(key) {
      let value = 0;
      if (
        this.getAllGlobalVariables &&
        this.getAllGlobalVariables.data &&
        this.getAllGlobalVariables.data.length
      ) {
        this.getAllGlobalVariables.data.forEach((element) => {
          if (element.label == key) {
            value = element.value;
            if (element.currency) {
              this.data.currency = element.currency;
            }
            if (element.input_type === "DATE") {
              if (element.datestamp) {
                value = moment().startOf("day");
              }
            }
          }
        });
        return value;
      } else {
        return "";
      }
    },

    isUniqueTimestampFormat(value) {
      const timestampRegex = /^[0-9]{13}$/; // 13 digits for Unix timestamp in milliseconds
      return timestampRegex.test(value);
    },
    evaluateDateExpression(expression, incrementType) {
      try {
        if (expression.includes("NaN") || expression.includes(undefined)) {
          return [];
        }
        const parts = expression.split("+");

        const results = [];
        let accumulateNumber = 0;

        for (const part of parts) {
          if (this.isUniqueTimestampFormat(part)) {
            const timestamp = parseInt(part);
            const currentDate = new Date(timestamp);
            let newDate = new Date(currentDate);

            switch (incrementType) {
              case "YYYY":
                newDate.setFullYear(
                  currentDate.getFullYear() + accumulateNumber
                );
                break;
              case "MM":
                newDate.setMonth(currentDate.getMonth() + accumulateNumber);
                break;
              default:
                newDate.setDate(currentDate.getDate() + accumulateNumber);
                break;
            }

            results.push(
              newDate.toDateString() +
                " " +
                newDate.toTimeString().slice(0, 8) +
                " GMT"
            );
            accumulateNumber = 0;
          } else if (
            part.includes("*") ||
            part.includes("+") ||
            part.includes("-")
          ) {
            accumulateNumber += mexp.eval(part);
          } else {
            results.push(accumulateNumber + mexp.eval(part));
            accumulateNumber = 0;
          }
        }

        return results;
      } catch (e) {
        // console.log("evaluateDateExpression", e);
      }
    },
    getTimeValue(timeString, type) {
      if (timeString && timeString.includes(":")) {
        const [hours, minutes, seconds] = timeString.split(":").map(Number);

        switch (type) {
          case "hours":
          case "hh":
            return hours;
          case "minutes":
          case "mm":
            return minutes;
          case "seconds":
            return seconds;
          default:
            return 0;
        }
      }
      return 0;
    },
    getFieldValue(field, data) {
      if (field?.key && this.data && data[field.key]) {
        if (field.input_type == "CHECKBOX") {
          return 1;
        }
        if (field.input_type == "INTEGRATION_VARIABLE") {
          const fullFieldData = this.fieldsData.find(
            (f) => f.key === field.key
          );
          if (fullFieldData) {
            const variableType =
              fullFieldData.integration_settings
                ?.selectedIntegrationFieldVariableType;
            if (variableType === "date") {
              const dateValue = data[field.key];
              if (dateValue) {
                return moment(dateValue).format("YYYY-MM-DD");
              }
            } else if (variableType === "select") {
              const integrationCalValue =
                data[`${field.key}/integrationCalvalue`];
              if (integrationCalValue) {
                return integrationCalValue || data[field.key];
              }
            } else {
              return moment(data[field.key]).format("YYYY-MM-DD");
            }
          }
        }
        return data[field.key];
      }
      return 0;
    },
    dateDifference(startDate, endDate, resultType = "DD") {
      const startMoment = moment(startDate);
      const endMoment = moment(endDate);
      switch (resultType.toUpperCase()) {
        case "DD":
          return endMoment.diff(startMoment, "days");
        case "MM":
          return endMoment.diff(startMoment, "months");
        case "YYYY":
          return endMoment.diff(startMoment, "years");
        case "MS":
          return endMoment.diff(startMoment, "minutes");
        case "HH":
          return endMoment.diff(startMoment, "hours");
        default:
          return endMoment.diff(startMoment, "days");
      }
    },
    timeDifference(startTime, endTime, resultType = "HH") {
      const format = "HH:mm:ss";
      const startMoment = moment(startTime, format, true);
      const endMoment = moment(endTime, format, true);

      if (!startMoment.isValid() || !endMoment.isValid()) {
        console.error("Invalid time format:", startTime, endTime);
        return 0;
      }

      switch (resultType.toUpperCase()) {
        case "HH":
          return endMoment.diff(startMoment, "hours", true);
        case "MM":
          return endMoment.diff(startMoment, "minutes", true);
        case "SS":
          return endMoment.diff(startMoment, "seconds", true);
        default:
          return 0;
      }
    },

    isDate(string) {
      var dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      var dateRegex1 = /^\d{2}-\d{2}-\d{4}$/;
      var timeRegex = /^\d{2}:\d{2}:\d{2}$/;
      let dateStamp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
      if (
        dateRegex.test(string) ||
        dateRegex1.test(string) ||
        dateStamp.test(string) ||
        timeRegex.test(string)
      ) {
        return true;
      }
      return false;
    },
    isTime(string) {
      var timeRegex = /^\d{2}:\d{2}:\d{2}$/;
      if (timeRegex.test(string)) {
        return true;
      }
      return false;
    },
    getMonthFromDate(dateString) {
      const date = new Date(dateString);
      return date.getMonth();
    },
    getDayFromDate(dateString) {
      const date = new Date(dateString);
      return date.getDate();
    },
    getHoursFromTime(timeString) {
      if (typeof timeString !== "string") {
        return 0;
      }

      if (!timeString.includes(":")) return 0;

      const timeParts = timeString.split(":");
      const min = parseInt(timeParts[1] || "0", 10);
      return min;
    },

    convertToDate(value, resultType = "DD") {
      let currentDate = moment("01-01-0001");
      switch (resultType) {
        case "MM":
          currentDate = moment("01-01-0001").add(value, "months");
          break;
        case "MS":
          currentDate = moment("01-01-0001").add(value, "minutes");
          break;
        case "DD":
          currentDate = moment("01-01-0001").add(value, "days");
          break;
        case "YYYY":
          currentDate = moment("01-01-0001").add(value, "years");
          break;
        case "HH":
          currentDate = moment("01-01-0001").add(value, "hours");
          break;
        default:
          currentDate = moment("01-01-0001").add(value, "days");
      }
      return currentDate;
    },
    convertToTime(value, resultType) {
      let currentTime = moment("00:00:00", "HH:mm:ss");

      switch (resultType) {
        case "HH":
          currentTime = moment("00:00:00", "HH:mm:ss").add(value, "hours");
          break;
        case "MM":
          currentTime = moment("00:00:00", "HH:mm:ss").add(value, "minutes");
          break;
        case "SS":
          currentTime = moment("00:00:00", "HH:mm:ss").add(value, "seconds");
          break;
        default:
          throw new Error(
            'Invalid result type. Please provide "HH", "mm", or "ss".'
          );
      }
      return currentTime;
    },
    setValueBasedOnFields(fields, data) {
      let expr = "",
        dateCount = 0,
        offsetHours = 0,
        timeCount = 0,
        offsetDays = 0,
        offsetMonths = 0,
        dateValuesCount = 0,
        timeFields = [],
        requiredFieldsEmpty = false,
        dateTimeCount = 0,
        offsetMinutes = 0,
        offsetSeconds = 0;
      fields.forEach((e) => {
        if (
          e?.type == "FIELD" ||
          e?.type == "FORMULA" ||
          e?.type == "GLOBAL_VARIABLE"
        ) {
          if (e?.input_type == "DATE_RANGE") {
            let value = this.getFieldValue(e, data);
            if (
              Array.isArray(value) &&
              value.length === 2 &&
              value[0] &&
              value[1]
            ) {
              let value1 = this.dateDifference(
                "01-01-0001",
                moment(value[0]).format("MM-DD-YYYY"),
                this.data.date_result_type
              );
              let value2 = this.dateDifference(
                "01-01-0001",
                moment(value[1]).format("MM-DD-YYYY"),
                this.data.date_result_type
              );
              let diff = value2 - value1;
              if (this.data.date_result_type === "DD") {
                diff += 1;
              }

              expr = expr + diff;
            }
          } else {
            let value =
              e.type == "GLOBAL_VARIABLE"
                ? this.getGlobalVariableValue(e.field_name)
                : this.getFieldValue(e, data);
            let isValueEmpty = false;
            if (e?.input_type === "DATE_RANGE") {
              isValueEmpty =
                !value ||
                !Array.isArray(value) ||
                value.length !== 2 ||
                !value[0] ||
                !value[1];
            } else if (e?.input_type === "TIME") {
              isValueEmpty =
                value === null || value === undefined || value === "";
            } else {
              isValueEmpty =
                (value === null || value === undefined || value === "") &&
                value !== 0;
            }

            if (isValueEmpty) {
              requiredFieldsEmpty = true;
            }

            if (
              (this.isDate(value) ||
                e.input_type == "DATE" ||
                e.input_type == "DATE_TIME") &&
              e.input_type != "TIME" &&
              e.inputType != "TIME"
            ) {
              if (value) {
                dateValuesCount++;
              }
              if (this.data.date_result_type != "DD") {
                offsetDays += this.getDayFromDate(value);
              }
              if (this.data.date_result_type == "YYYY") {
                offsetMonths += this.getMonthFromDate(value);
              }
              if (e.input_type == "DATE_TIME") {
                dateTimeCount++;
                offsetHours += new Date(value).getHours();
                offsetMinutes += new Date(value).getMinutes();
                offsetSeconds += new Date(value).getSeconds();
              }
              dateCount++;
              value = this.dateDifference(
                "01-01-0001",
                value,
                this.data.date_result_type
              );
            }
            if (this.isTime(value) || e.input_type == "TIME") {
              timeFields.push(value);
              if (this.data.time_result_type != "HH") {
                offsetHours += this.getHoursFromTime(value);
              }
              timeCount++;

              if (typeof value === "number" && value !== 0) {
                const formattedTime = moment.utc(value).format("HH:mm:ss");
                value = this.timeDifference(
                  "00:00:00",
                  formattedTime,
                  this.data.time_result_type
                );
              } else if (typeof value === "string") {
                value = this.timeDifference(
                  "00:00:00",
                  value,
                  this.data.time_result_type
                );
              } else {
                value = 0;
              }
            }
            expr = expr + value;
          }
        } else if (e?.type == "OPERATOR") {
          expr = expr + e.operator;
        } else if (e?.type == "NUMBER") {
          expr = expr + e.number;
        } else if (e?.type == "PARENTHESES") {
          expr = expr + e.parentheses;
        }
      });
      if (requiredFieldsEmpty) {
        this.$set(this.form, this.data.key, "");
        return;
      }
      try {
        let calculatedValue = mexp.eval(expr);

        if (calculatedValue == Infinity) {
          calculatedValue = 0;
        }
        let finalValue = calculatedValue;

        if (Number(finalValue) && this.data.decimals) {
          finalValue = parseFloat(finalValue).toFixed(this.data.decimals || 0);
        } else if (this.data.date_result_type && dateCount == 2) {
          if (dateValuesCount == dateCount) {
            finalValue = parseFloat(finalValue).toString();
          } else {
            finalValue = 0;
          }
        } else if (this.data.time_result_type && timeCount == 2) {
          if (dateValuesCount == dateCount) {
            if (finalValue < 0) {
              if (this.data.time_result_type == "SS") {
                finalValue = 24 * 60 * 60 + finalValue;
              } else if (this.data.time_result_type == "MM") {
                finalValue = 24 * 60 + finalValue;
              } else if (this.data.time_result_type == "HH") {
                finalValue = 24 + finalValue;
              }
            }
            finalValue = Math.abs(parseFloat(finalValue).toString());
          } else {
            finalValue = 0;
          }
        } else if (dateCount == 1) {
          finalValue = this.convertToDate(
            finalValue,
            this.data.date_result_type
          );
          if (offsetDays > 2 && dateTimeCount == 0) {
            finalValue = moment(finalValue).add(offsetDays - 2, "days");
          }
          if (this.data.date_result_type == "YYYY" && offsetMonths > 0) {
            finalValue = moment(finalValue).add(offsetMonths, "month");
          }
          if (timeCount == 1 && timeFields.length == 1) {
            finalValue = this.addTimeToDate(finalValue, timeFields[0]);
          }
          if (offsetHours > 1) {
            if (dateTimeCount == 0 && this.data.input_type === "DATE_TIME") {
              finalValue = moment(finalValue).add(offsetHours, "hours");
            }
            if (dateTimeCount > 0 && this.data.date_result_type === "HH") {
              finalValue = moment(finalValue)
                .add(offsetMinutes, "minutes")
                .add(offsetSeconds, "seconds");
            }
            if (
              dateTimeCount > 0 &&
              this.data.date_result_type === "DD" &&
              offsetHours &&
              offsetMinutes
            ) {
              finalValue = moment(finalValue)
                .add(offsetHours, "hours")
                .add(offsetMinutes, "minutes")
                .add(offsetSeconds, "seconds");
            }
            finalValue = moment(finalValue, "MM-dd-yyyy HH:mm:ss")
              .utc()
              .toISOString();
          } else if (this.data.date_result_type === "MS") {
            finalValue = moment(finalValue).add(offsetSeconds, "seconds");
            finalValue = moment(finalValue, "MM-dd-yyyy HH:mm:ss")
              .utc()
              .toISOString();
          } else {
            finalValue = moment(
              finalValue,
              this.getDefaultDateFormat
                ? this.getDefaultDateFormat
                : "MM-DD-YYYY"
            )
              .startOf("day")
              .utc()
              .toISOString();
          }
          if (!dateValuesCount) {
            finalValue = "";
          }
        } else if (this.data.time_result_type && timeCount == 1) {
          finalValue = this.convertToTime(
            finalValue,
            this.data.time_result_type
          );

          finalValue = moment(finalValue).format("HH:mm:ss");
        }
        if (!isNaN(Number(finalValue))) {
          finalValue = Number(finalValue);
        }
        this.$set(this.form, this.data.key, finalValue);
      } catch (err) {
        if (this.form[this.data.key] != 0 && this.form[this.data.key] != "0") {
          this.$set(this.form, this.data.key, 0);
        }
      }
    },
    addTimeToDate(date, timeToAdd) {
      let [hours, minutes, seconds] =
        timeToAdd && timeToAdd.includes(":")
          ? timeToAdd.split(":").map(Number)
          : [0, 0, 0];
      let newDate = new Date(date);
      newDate.setHours(newDate.getHours() + hours);
      newDate.setMinutes(newDate.getMinutes() + minutes);
      newDate.setSeconds(newDate.getSeconds() + (seconds || 0));
      return newDate;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-col-4 {
  // height: 20px;
}
.el-input {
  width: 100% !important;
  border: none !important;
  background: transparent !important;
}
.disabled-field {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed;
  color: #c0c4cc;
  pointer-events: painted;
  cursor: not-allowed;
}

.el-input:focus {
  border: none !important;
  outline: none !important;
}

.custom-input {
  border: 1px;

  &:focus {
    outline: none;
    // border-color: #f7f3f3;
  }
}

.left-aligned-input {
  text-align: left;
}

.right-aligned-input {
  text-align: right;
}

.center-aligned-input {
  text-align: center;
}

.nfe {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 32px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  &:hover {
    border-color: #409eff; /* Change the border color on hover */
  }
  &:focus {
    border-color: #409eff; /* Change the border color when focused */
  }
  &::placeholder {
    color: #ccc; /* Use your desired lighter gray color here */
  }
  @media only screen and (max-width: 767px) {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 16px !important;
    height: 32px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }
}
.fontSty {
  font-weight: normal;
}
</style>
